"use strict";
/**
 * UUID Validator
 * Validates UUID format (v4 and v7 support)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidUuid = isValidUuid;
exports.validateUuid = validateUuid;
exports.isUuidV7 = isUuidV7;
exports.isUuidV4 = isUuidV4;
/**
 * UUID v4/v7 regex pattern
 * Supports both UUIDv4 and UUIDv7 formats
 */
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[47][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
/**
 * Validates if a string is a valid UUID (v4 or v7)
 *
 * @param value - Value to validate
 * @returns True if valid UUID, false otherwise
 *
 * @example
 * ```typescript
 * isValidUuid('019aa5e7-5325-7187-b3eb-7b4b3814b078'); // true (v7)
 * isValidUuid('f47ac10b-58cc-4372-a567-0e02b2c3d479'); // true (v4)
 * isValidUuid('invalid-guid'); // false
 * isValidUuid(''); // false
 * ```
 */
function isValidUuid(value) {
    if (!value || typeof value !== 'string') {
        return false;
    }
    return UUID_REGEX.test(value);
}
/**
 * Validates UUID and throws error if invalid
 *
 * @param value - Value to validate
 * @param paramName - Parameter name for error message
 * @throws Error if UUID is invalid
 *
 * @example
 * ```typescript
 * validateUuid('019aa5e7-5325-7187-b3eb-7b4b3814b078', 'userId'); // OK
 * validateUuid('invalid-guid', 'userId'); // throws Error
 * ```
 */
function validateUuid(value, paramName = 'value') {
    if (!isValidUuid(value)) {
        throw new Error(`Invalid UUID format for parameter '${paramName}': ${value}`);
    }
}
/**
 * Checks if UUID is version 7 (time-ordered)
 *
 * @param uuid - UUID to check
 * @returns True if UUIDv7, false otherwise
 */
function isUuidV7(uuid) {
    if (!isValidUuid(uuid)) {
        return false;
    }
    // Check version byte (position 14, should be '7')
    return uuid[14] === '7';
}
/**
 * Checks if UUID is version 4 (random)
 *
 * @param uuid - UUID to check
 * @returns True if UUIDv4, false otherwise
 */
function isUuidV4(uuid) {
    if (!isValidUuid(uuid)) {
        return false;
    }
    // Check version byte (position 14, should be '4')
    return uuid[14] === '4';
}
